/**
 * RoyalEngagement — design tokens.
 *
 * Deep maroon, gold, and ivory palette for a North Indian
 * royal engagement (Rajput/Punjabi style).
 */

import type { CSSProperties } from 'react';

export interface RoyalTheme {
  maroon: string;
  maroonDark: string;
  gold: string;
  goldSoft: string;
  ivory: string;
  ivoryDark: string;
  ink: string;
  muted: string;
  border: string;
}

export const royalTheme: RoyalTheme = {
  maroon: '#720e1e',
  maroonDark: '#4a0914',
  gold: '#c9a227',
  goldSoft: '#f0e0a0',
  ivory: '#fdf8ee',
  ivoryDark: '#f5ecd8',
  ink: '#1f0a0e',
  muted: '#7a5e5e',
  border: 'rgba(114,14,30,0.12)',
};

export const ROYAL_EASE = [0.22, 1, 0.36, 1] as const;

export function themeCssVars(theme: RoyalTheme): CSSProperties {
  return {
    '--royal-maroon': theme.maroon,
    '--royal-maroon-dark': theme.maroonDark,
    '--royal-gold': theme.gold,
    '--royal-gold-soft': theme.goldSoft,
    '--royal-ivory': theme.ivory,
    '--royal-ivory-dark': theme.ivoryDark,
    '--royal-ink': theme.ink,
    '--royal-muted': theme.muted,
    '--royal-border': theme.border,
  } as CSSProperties;
}
